import {atom} from 'jotai';

import {CasusMasterData} from '@lexian/api/casus-api';
import {ContactMasterData} from '@lexian/api/contacts-api';
import {InvoicingMasterData} from '@lexian/api/invoicing-api';
import {
  LexianFrontendSettings,
  SupportMasterData,
} from '@lexian/api/support-api';
import {TimetrackingMasterData} from '@lexian/api/time-tracking-api';

export type MasterData = SupportMasterData &
  ContactMasterData &
  InvoicingMasterData &
  CasusMasterData &
  TimetrackingMasterData &
  LexianFrontendSettings;

export const masterdataState = atom<MasterData | undefined>(undefined);
